export const checkRoles = (userRoles: string[], allowedRoles: string[]): boolean =>
  userRoles.some(role => allowedRoles.includes(role));
